import React, { useState, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { Toast } from 'primereact/toast';

const Orders = () => {
  const toast = useRef(null);
  const [orders] = useState([
    {
      id: 'ORD-001',
      date: new Date('2024-03-15'),
      total: 75.00,
      status: 'completed',
      items: 'Annual Membership, Event Registration'
    },
    {
      id: 'ORD-002',
      date: new Date('2024-02-28'),
      total: 25.00,
      status: 'completed',
      items: 'Horse Registration (Thunder)'
    },
    {
      id: 'ORD-003',
      date: new Date('2024-01-15'),
      total: 150.00,
      status: 'pending',
      items: 'Premium Membership, Event Package'
    }
  ]);

  const statusBodyTemplate = (rowData) => {
    const severity = rowData.status === 'completed' ? 'success' : 
                    rowData.status === 'pending' ? 'warning' : 'danger';
    return <Badge value={rowData.status.toUpperCase()} severity={severity} />;
  };

  const dateBodyTemplate = (rowData) => {
    return rowData.date.toLocaleDateString('en-GB');
  };

  const priceBodyTemplate = (rowData) => {
    return `£${rowData.total.toFixed(2)}`;
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <Button 
        icon="pi pi-eye" 
        className="p-button-text" 
        tooltip="View Invoice"
        onClick={() => {
          toast.current?.show({
            severity: 'info',
            summary: 'Invoice',
            detail: `Viewing invoice for order ${rowData.id}`,
            life: 3000
          });
        }}
      />
    );
  };

  return (
    <div>
      <Toast ref={toast} />
      <div className="se-card">
        <div className="se-card-header">
          <h2>Orders</h2>
        </div>
        <div className="se-card-content">
          <DataTable value={orders} responsiveLayout="scroll">
            <Column field="id" header="Order ID" sortable />
            <Column field="date" header="Order Date" body={dateBodyTemplate} sortable />
            <Column field="total" header="Total Price" body={priceBodyTemplate} sortable />
            <Column field="status" header="Status" body={statusBodyTemplate} sortable />
            <Column header="Invoice" body={actionBodyTemplate} />
          </DataTable>
        </div>
      </div>
    </div>
  );
};

export default Orders;